<div class="space-y-3">
  <div>
    <div class="flex items-center justify-between gap-2">
      <label class="block text-sm font-medium text-secondary" [for]="'video-link-' + post().id">videoLink</label>
      <button
        type="button"
        (click)="viewPost()"
        [disabled]="!videoLink().trim()"
        aria-label="View post in new tab"
        class="inline-flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-border bg-muted text-secondary transition-colors hover:bg-muted/80 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-50">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="size-4" aria-hidden="true">
          <path d="M15 3h6v6" />
          <path d="M10 14 21 3" />
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        </svg>
      </button>
    </div>
    <input
      [id]="'video-link-' + post().id"
      type="url"
      class="mt-1 block w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-primary shadow-sm read-only:bg-muted/40"
      [value]="videoLink()"
      (input)="onVideoLinkInputEvent($event)"
      [readonly]="!canEditPosts() || saveLoading()"
      [attr.aria-readonly]="!canEditPosts() || saveLoading()" />
    @if (resolveError(); as resolveErrorMessage) {
    <p class="mt-1 text-xs text-amber-800 dark:text-amber-200" role="status">{{ resolveErrorMessage }}</p>
    } @else if (canEditPosts()) {
    <p class="mt-1 text-xs text-secondary">
      fullUrl preview updates as you type; saved with Save post fields.
    </p>
    } @else {
    <p class="mt-1 text-xs text-secondary">
      Copy the URL from the field, or open the live post with the button above.
    </p>
    }
  </div>

  <div>
    <span class="block text-sm font-medium text-secondary" [id]="'full-url-label-' + post().id">fullUrl</span>
    @if (resolveLoading()) {
    <div
      class="mt-1 h-3.5 w-full max-w-md animate-pulse rounded-full bg-muted"
      role="status"
      aria-live="polite"
      [attr.aria-labelledby]="'full-url-label-' + post().id"
      aria-busy="true"
      aria-label="Generating fullUrl from videoLink"></div>
    } @else if (getDisplayedFullUrl(); as displayedFullUrl) {
    <p class="mt-1 break-all text-sm text-primary" [attr.aria-labelledby]="'full-url-label-' + post().id">
      {{ displayedFullUrl }}
    </p>
    @if (hasUnsavedFullUrlPreview()) {
    <p class="mt-1 text-xs text-secondary">Unsaved preview — click Save post fields to persist.</p>
    } @else {
    <p class="mt-1 text-xs text-secondary">Read-only — derived from videoLink.</p>
    }
    } @else {
    <p class="mt-1 text-sm italic text-secondary" [attr.aria-labelledby]="'full-url-label-' + post().id">
      Enter or update videoLink to generate fullUrl.
    </p>
    <p class="mt-1 text-xs text-secondary">Read-only — derived from videoLink.</p>
    }
  </div>

  <div>
    <label class="block text-sm font-medium text-secondary" [for]="'ad-code-' + post().id">adCode</label>
    @if (isInstagramStory()) {
    <p class="mt-1 text-sm italic text-secondary">Not available for Stories</p>
    } @else {
    <input
      [id]="'ad-code-' + post().id"
      type="text"
      class="mt-1 block w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-primary shadow-sm read-only:bg-muted/40"
      [value]="adCode()"
      (input)="onAdCodeInputEvent($event)"
      [readonly]="!canEditPosts() || saveLoading()"
      [attr.aria-readonly]="!canEditPosts() || saveLoading()" />
    }
  </div>

  <div class="flex items-center justify-between gap-2">
    <p class="text-xs text-secondary">resultsVersion: {{ post().resultsVersion ?? '—' }}</p>
    @if (canEditPosts()) {
    <button
      type="button"
      class="rounded-lg bg-primary px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
      (click)="savePostFields()"
      [disabled]="saveLoading() || resolveLoading()">
      @if (saveLoading()) {
      Saving…
      } @else {
      Save post fields
      }
    </button>
    }
  </div>
</div>
